<template>
  <div class="relative">
    <TransitionGroup
      name="list"
      tag="ul"
      class="absolute right-2 top-2 z-50 w-[90%] sm:w-[500px]"
      enter-active-class="transition duration-3000 ease-out"
      enter-from-class="scale-95 translate-x-full opacity-0"
      enter-to-class="scale-100 opacity-100"
      leave-active-class="transition duration-3000 ease-in"
      leave-from-class="scale-100 opacity-100"
      leave-to-class="scale-95 opacity-0"
    >
      <li v-for="alert in state.alerts" :key="alert.id">
        <YapBannerNotification :alert="alert" />
      </li>
    </TransitionGroup>
  </div>
</template>

<script setup lang="ts">
import { computed, reactive } from 'vue';

import { useAlertStore, Alert } from '@/store/alertsStore';
import YapBannerNotification from '@/components/notification/YapBannerNotification.vue';

const alertStore = useAlertStore();

interface State {
  hasGlobalAlert: boolean;
  alerts: Array<Alert>;
}
const state: State = reactive({
  hasGlobalAlert: computed(() => !!alertStore.alerts.length),
  alerts: computed(() => alertStore.alerts)
});
</script>
